import * as sterlingparker from './MarketsAccordionItem.styles.sterlingparker';
import * as betroyale from './MarketsAccordionItem.styles.betroyale';
import * as betprofessor from './MarketsAccordionItem.styles.betprofessor';
import * as forsport from './MarketsAccordionItem.styles.forsport';
import * as fiestabet from './MarketsAccordionItem.styles.fiestabet';
import * as goldenrush from './MarketsAccordionItem.styles.goldenrush';
import * as juicybet from './MarketsAccordionItem.styles.juicybet';
import * as betgalaxy from './MarketsAccordionItem.styles.betgalaxy';
import * as puntcity from './MarketsAccordionItem.styles.puntcity';
import * as puntgenie from './MarketsAccordionItem.styles.puntgenie';
import * as questbet from './MarketsAccordionItem.styles.questbet';
import * as vikingbet from './MarketsAccordionItem.styles.vikingbet';
import * as volcanobet from './MarketsAccordionItem.styles.volcanobet';
import * as wellbet from './MarketsAccordionItem.styles.wellbet';
import * as junglebet from './MarketsAccordionItem.styles.junglebet';
import * as oldgill from './MarketsAccordionItem.styles.oldgill';
import * as chromabet from './MarketsAccordionItem.styles.chromabet';
import * as titanbet from './MarketsAccordionItem.styles.titanbet';
import * as epicodds from './MarketsAccordionItem.styles.epicodds';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  juicybet,
  fiestabet,
  forsport,
  goldenrush,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  junglebet,
  oldgill,
  chromabet,
  titanbet,
  epicodds,
};
